import { create } from "zustand";
import { persist } from "zustand/middleware";

const userStore = create(
  (set, get) => ({
    userIsConnected: false,
    userPseudo: "",
    userPermalink: "",
    userAvatar: "",
    userBandeau: "",
    userNotifications: 0,
    userMessages: 0,
    setUserIsConnected: (userIsConnected) => set({ userIsConnected }),
    setUserPseudo: (userPseudo) => set({ userPseudo }),
    setUserPermalink: (userPermalink) => set({ userPermalink }),
    setUserAvatar: (userAvatar) => set({ userAvatar }),
    setUserBandeau: (userBandeau) => set({ userBandeau }),
    setUserNotifications: (userNotifications) => set({ userNotifications }),
    setUserMessages: (userMessages) => set({ userMessages }),

    // pas besoin d'être membre ou connecté
    userNsfw: false,
    setUserNsfw: (userNsfw) => set({ userNsfw }),

    userNsfwInFeed: false,
    setUserNsfwInFeed: (userNsfwInFeed) => set({ userNsfwInFeed }),

    userVue: "cartes",
    setUserVue: (userVue) => set({ userVue }),
  }),
  {
    name: "user", // name of the item in the storage (must be unique)
    // storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
  }
);

export default userStore;
